import { createSlice } from "@reduxjs/toolkit";

import { clearStore } from "actions/initialization";
import { modelsListThunk, ttsVoicesListThunk } from "thunks/model";
import { isPendingAction, isRejectedAction } from "utils";

const initialState = {
  ids: [],
  hash: {},
  tts: {
    ids: [],
    hash: {},
    voices: {},
  },
  loading: false,
  error: null,
};

const actionsToFilter = {
  pending: [modelsListThunk.pending, ttsVoicesListThunk.pending],
  rejected: [modelsListThunk.rejected, ttsVoicesListThunk.rejected],
};

const modelDTO = (model) => {
  let extraData = {};
  // TODO this will be replaced with BE
  // if (
  //   initialVoicesHash[model.name.toLowerCase()] &&
  //   [
  //     MODEL_VISIBILITY.public,
  //     MODEL_VISIBILITY.paid,
  //     MODEL_VISIBILITY.kids,
  //   ].includes(model.visibility)
  // ) {
  //   const {
  //     src1,
  //     src2,
  //     orig1,
  //     orig2,
  //     restricted,
  //     group,
  //     gender,
  //     age,
  //     type,
  //     pitch,
  //   } = initialVoicesHash[model.name.toLowerCase()];
  //   extraData = {
  //     src1,
  //     src2,
  //     orig1,
  //     orig2,
  //     restricted,
  //     group,
  //     gender,
  //     age,
  //     type,
  //     pitch,
  //   };
  // }
  return {
    ...extraData,
    id: model.id,
    name: model.name,
    owner: model.owner,
    params: model.params.reduce((acc, p) => {
      acc[p.id] = p.default;
      return acc;
    }, {}),
    heartbeat: true,
    m2o: model.m2o,
    visibility: model.visibility,
    user_can_use_model: model.user_can_use_model,
  };
};

const modelSlice = createSlice({
  name: "model",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #region pending
      // #endregion
      // #region fulfilled
      .addCase(modelsListThunk.fulfilled, (state, action) => {
        state.ids = [];
        state.hash = {};
        state.loading = false;
        const { list } = action.payload;
        list.forEach((model) => {
          if (!state.ids.includes(model.id)) {
            state.ids.push(model.id);
          }
          state.hash[model.id] = modelDTO(model);
        });
      })
      .addCase(ttsVoicesListThunk.fulfilled, (state, action) => {
        const voices = action.payload;
        state.loading = false;
        state.tts.ids = [];
        state.tts.hash = {};
        voices.forEach((voice) => {
          state.tts.ids.push(voice.id);
          state.tts.hash[voice.id] = voice;
        });
      })
      // #endregion
      // #region rejected
      // #endregion
      .addCase(clearStore, () => initialState)
      .addMatcher(isPendingAction(actionsToFilter.pending), (state) => {
        state.loading = true;
      })
      .addMatcher(
        isRejectedAction(actionsToFilter.rejected),
        (state, action) => {
          // Read from action.error (always present) rather than action.payload,
          // which is undefined when the thunk rejects via a thrown error and
          // would throw on destructure.
          const { error } = action;
          state.loading = false;
          state.error = error;
        }
      );
  },
});

export const actions = modelSlice.actions;

export default modelSlice.reducer;
